<div class="pos-relative full-grow-no-shrink-no-basis">
  <div class="editor-container">
    <!--    TODO: Don't remove the following line. Need to update it with ckeditor5-->
    <!--    <ckeditor [ngModelOptions]="{standalone: true}"-->
    <!--              [(ngModel)]="ckeditorContent"-->
    <!--              [config]="ckeConfig"-->
    <!--              [readonly]="false"-->
    <!--              (change)="onChange($event)"-->
    <!--              (editorChange)="onEditorChange($event)"-->
    <!--              (ready)="onReady($event)"-->
    <!--              (focus)="onFocus($event)"-->
    <!--              (blur)="onBlur($event)"-->
    <!--              (contentDom)="onContentDom($event)"-->
    <!--              (fileUploadRequest)="onFileUploadRequest($event)"-->
    <!--              (fileUploadResponse)="onFileUploadResponse($event)"-->
    <!--              (paste)="onPaste($event)"-->
    <!--              (drop)="onDrop($event)"-->
    <!--              >-->
    <!--    </ckeditor>-->
  </div>
</div>
